module.exports = __webpack_public_path__ + "static/media/USK9.d6ed0366.ico";